import summaryStore from "@/store/summary.store";
import { FetchSummaryCommonParams } from "@/types/summary";
import { useEffect, useRef } from "react";

const usePollingSummary = (commonInitParam?: FetchSummaryCommonParams | null) => {
  const pollingSummaryRef = useRef<NodeJS.Timeout>();
  const abortControllerRef = useRef(new AbortController());

  useEffect(() => {
    abortControllerRef.current = new AbortController();
    return () => {
      pollingSummaryRef.current && clearTimeout(pollingSummaryRef.current);
      abortControllerRef.current.abort();
    };
  }, []);

  // 轮询获取纪要
  const pollingSummary = async () => {
    if (!commonInitParam) return;
    summaryStore.getState().setSummaryLoading(true);
    const res = await summaryStore.getState().fetchSummary(commonInitParam, false, {
      signal: abortControllerRef.current.signal,
    });

    if (res && !res.summaryFinish) {
      pollingSummaryRef.current = setTimeout(() => {
        pollingSummary();
      }, 3000);
    } else if (res && res.summaryFinish) {
      summaryStore.getState().setSummaryLoading(false);
      summaryStore.getState().setSummaryStreamsAllDone(true);
    }
  };

  return { pollingSummary, pollingSummaryRef };
};

export default usePollingSummary;
